import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty, max as _max, cloneDeep as _cloneDeep } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import { HighChart } from "../../../resusableComponents/common/formElements";
import { withRouter } from "../../../resusableComponents/hoc/withRouter";

import { thousandSeparator } from "../../../helpers/utils";

class Charts extends Component {

  constructor(props) {
    super(props);

    this.chartDefaultOptions = {
      title: { text: "" },
      chart: { type: "bar", marginRight: 50, marginTop: 20, height: 290 },
      plotOptions: {
        bar: { dataLabels: { enabled: false } },
        column: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return thousandSeparator(this.y);
            },
          },
          borderWidth: 1,
        },
        series: {}
      },
      colors: ["#5C2056", "#6B2363", "#792972", "#9A338F", "#A24699", "#AB57A2", "#B66BAE", "#BD7BB8", "#C690C2", "#DAB5D6"],
      xAxis: { categories: [] },
      yAxis: {},
      options: { responsive: true },
      legend: { enabled: false },
      series: [{ color: { linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 }, stops: [[0, "#66b2b2"], [1, "#0de8f4"]] }, data: [] }],
      credits: { enabled: false }
    };

    this.state = {
      chartOptions: { ...this.chartDefaultOptions },
      chartToggle: "value"
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if ((!_isEqual(prevProps.chartData, this.props.chartData) || !_isEqual(prevState.chartToggle, this.state.chartToggle)) &&
      !_isEmpty(this.props.chartData)
    ) {
      const { chartData } = this.props;
      const { chartToggle } = this.state;
      const tempChartData = _cloneDeep(chartData);

      let xAxisData = _get(tempChartData, "categories", []);
      let seriesData = ((chartToggle === "percentage") ? _get(tempChartData, "percentage", []) : _get(tempChartData, "total", []));
      const maxYAxis = ((chartToggle === "percentage") ? { max: 100 } : { max: ((_max(seriesData) || 0)) });

      this.setState({
        chartOptions: {
          ...this.chartDefaultOptions,
          xAxis: {
            categories: (xAxisData || [])
          },
          yAxis: {
            min: 0,
            ...maxYAxis,
            showEmpty: false,
            labels: {
              align: "right",
              formatter: function () {
                return (((chartToggle || "percentage") === "percentage") ? (`${(this.value || 0)} %`) : thousandSeparator(this.value || 0));
              }
            }
          },
          tooltip: {
            formatter: function () {
              return `<b>${this.point.category}</b>: ${((chartToggle === "percentage") ? (`${(this.point.y || 0)} %`) : thousandSeparator(this.point.y || 0))}`;
            },
          },
          series: [{
            data: seriesData,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [[0, "#66b2b2"], [1, "#66b2b2"]]
            }
          }],
        },
        jobFunctionLoader: false
      });
    }
  }

  render() {
    const { title } = this.props;
    const { chartOptions, chartToggle } = this.state;

    return (
      <div className="col-lg-6">
        <div className="card shadow-none">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 justify-content-between mb-4">
              <h6 className="heading-04 fw-semibold mb-8">{(title || "")}</h6>

              <label className="switch">
                <input
                  type="checkbox"
                  className="switch-input"
                  checked={((chartToggle === "percentage") ? true : false)}
                  onChange={(e) => {
                    this.setState({
                      chartToggle: ((_get(e, "currentTarget.checked", false) === false) ? "value" : "percentage")
                    });
                  }}
                />
                <div className="switch-slider">
                  <span className="switch-on">
                    <FormattedMessage id="dataSearch.search_data.chart.percent_on" defaultMessage="% ON" />
                  </span>
                  <span className="switch-off">
                    <FormattedMessage id="dataSearch.search_data.chart.percent_off" defaultMessage="% OFF" />
                  </span>
                </div>
              </label>
            </div>
            <div>
              <HighChart options={(chartOptions || {})} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(injectIntl(Charts));
